import React from 'react'
import {Button} from "./Button"
import "./HeroSection.css"
import "../App.css"
function HeroSection() {
    return (
        <div className="hero-container">
            <h1>ADVENTURE AWAITS</h1>
            <p>what are you waiting for?</p>
            <div className="hero-btns">
               <Button className="btns" buttonStyle="btn--outline" buttonSize="btn--large">
                GET STARTED   
               </Button> 
               <Button className="btns" buttonStyle="btn--primary" buttonSize="btn--large">
                WATCH TRAILOR <i className="far fa-play-circle" />  
               </Button>    
            </div> 
        </div>
    )
}

export default HeroSection;
